import { Campaign } from "@vviinn/user-managment-client-ts";

export const assignedCategoriesPredicate = (c?: Campaign): boolean => {
  if (!c || !c.linkedCategories || c.type === "VPD") return false;
  const source = c?.linkedCategories?.source;
  const target = c?.linkedCategories?.target;

  if (!target) return false;
  return (
    source?.googleFeedCategories !== undefined ||
    source?.productTypeCategories !== undefined ||
    target?.googleFeedCategories !== undefined ||
    target?.productTypeCategories !== undefined
  );
};
